import PropTypes from 'prop-types';
import React from 'react';
import StyledComponent from '~/components/Styled/Styled';
import Layout from '~/components/Layout/Layout';
import Link from '~/components/Link/Link';
import Button from '~/components/Button/Button';

import css from './EmptyState.scss';

export class EmptyState extends React.Component {
  render() {
    const { title, message, buttonCaption, backRoute } = this.props;
    return (
      <Layout>
        <div className={css.cardContainer}>
          <div className={css.messageContainer}>
            <img className={css.mainImage} src="/static/vectors/empty-state.svg" alt="No results" />
            <div className={css.copy}>
              <span className={css.title}>{title}</span>
              <div className={css.message}>{message}</div>
            </div>
            <Link route={backRoute}>
              <a className={css.button}>
                <Button width="193px" height="38px" copy={buttonCaption} />
              </a>
            </Link>
          </div>
        </div>
      </Layout>
    );
  }
}

EmptyState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  buttonCaption: PropTypes.string,
  backRoute: PropTypes.string,
};

EmptyState.defaultProps = {
  title: '',
  message: '',
  buttonCaption: '',
  backRoute: '',
};

export default StyledComponent(EmptyState, [css]);
